export default {"src":"/_next/static/media/get_bonus.b2c9be2f.svg","height":14,"width":68,"blurWidth":0,"blurHeight":0};